import React, { useEffect, useState } from "react";
import "./DocumentosMatricula.css";
import {
  insertRutaConstancia,
  insertarApiUploadFile,
  listado_constacias_cronogramapagos,
  listado_constacias_datosconstancia,
  listado_constacias_datoshorario,
  listado_constacias_habilitadas,
  listado_constacias_habilitadas_sinLoading,
} from "../../services/procesoMatricula/procesoMatricula";
import useMatricula from "../../hooks/useMatricula";
import useProcesoMatricula from "../../hooks/useProcesoMatricula";
import { pdf } from "@react-pdf/renderer";

import ConstanciaMatricula from "../plantillasPdfs/ConstanciaMatricula/ConstanciaMatricula";
import CronogramaDePago from "../plantillasPdfs/CronogramaDePago/CronogramaDePago";
import { HorarioPdf } from "../plantillasPdfs/Horario";

const groupById = (datatosConstacias) => {
  let grupos = Object.values(
    datatosConstacias.reduce((result, item) => {
      const key = item.ccurso + item.scurso;
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(item);
      return result;
    }, {})
  );
  return grupos;
};

const DocumentosMatricula = ({ sinTitulo = true }) => {
  const { obtenerDatosEstudiante } = useMatricula();

  const { setLoading, setErrorCursoServices } = useProcesoMatricula();
  const [listConstanciaHabilitadas, setListConstanciaHabilitadas] = useState(
    []
  );

  const {
    ndocidentidad,
    dperiodo,
    calumno,
    cpersona,
    cprograma,
  } = obtenerDatosEstudiante || {};
  useEffect(() => {
    if ("gencuesta" in (obtenerDatosEstudiante || {})) {
      listado_constacias_habilitadas(
        obtenerDatosEstudiante,
        setListConstanciaHabilitadas,
        setLoading
      );
    }
  }, [obtenerDatosEstudiante]);

  const datosConstan1 = (datatosConstacia) => {
    function paginateArray(
      data,
      maxGroupsFirstPage,
      maxGroupsPerPage,
      maxRowsPerPage
    ) {
      const result = {};
      let currentPageIndex = 0;
      let currentGroupIndex = 0;
      let currentRowCount = 0;
      let currentPageRowCount = 0; // Contador de filas en la página actual

      const largeGroups = []; // Almacenar grupos con más de 16 elementos

      data.forEach((item) => {
        const ccurso = item.ccurso;
        const cgrupo = item.cgrupo;

        // Verificar si el grupo supera el límite de 16 elementos
        if (
          currentRowCount === 0 &&
          currentGroupIndex === 0 &&
          currentRowCount + item.length > maxRowsPerPage
        ) {
          largeGroups.push(currentGroupIndex); // Agregar el índice del grupo a largeGroups
        }

        if (
          currentRowCount === 0 &&
          currentPageIndex === 0 &&
          Object.keys(result).length >= maxGroupsFirstPage
        ) {
          currentGroupIndex++;
          if (currentGroupIndex === maxGroupsPerPage) {
            currentGroupIndex = 0;
            currentPageIndex++;
            currentPageRowCount = 0; // Reiniciar el contador de filas en la nueva página
          }
        }

        const currentPageKey = currentPageIndex.toString();

        if (!result[currentPageKey]) {
          result[currentPageKey] = {};
        }

        const currentPage = result[currentPageKey];

        const currentGroupKey = `${ccurso}-${cgrupo}`;

        if (!currentPage[currentGroupKey]) {
          currentPage[currentGroupKey] = [];
        }

        const currentGroup = currentPage[currentGroupKey];

        if (
          currentGroup.length < maxRowsPerPage &&
          currentPageRowCount < maxRowsPerPage
        ) {
          currentGroup.push(item);
          currentRowCount++;
          currentPageRowCount++;
        } else {
          currentRowCount = 0;
          currentGroupIndex++;
          currentPageRowCount = 0; // Reiniciar el contador de filas en el nuevo grupo
          if (!result[(currentPageIndex + 1).toString()]) {
            result[(currentPageIndex + 1).toString()] = {};
          }
          const nextPage = result[(currentPageIndex + 1).toString()];
          nextPage[currentGroupKey] = [item];
          currentPageIndex++;
        }
      });

      // Mover los grupos grandes a una página individual
      if (largeGroups.length > 0) {
        largeGroups.forEach((groupIndex) => {
          const groupKeys = Object.keys(result[currentPageIndex.toString()]);
          const groupKey = groupKeys[groupIndex];
          const groupData = result[currentPageIndex.toString()][groupKey];
          delete result[currentPageIndex.toString()][groupKey];
          result[(currentPageIndex + 1).toString()][groupKey] = groupData;
        });
      }

      // Limpiar grupos vacíos
      Object.values(result).forEach((page) => {
        Object.keys(page).forEach((groupKey) => {
          if (page[groupKey].length === 0) {
            delete page[groupKey];
          }
        });
      });
      // Obtener los resultados en el formato deseado
      const formattedResult = Object.entries(result).map(
        ([pageIndex, page]) => {
          const formattedGroups = Object.entries(page).map(
            ([groupKey, group]) => {
              const formattedGroup = group.map((item) => {
                const { ccurso, cgrupo, ...rest } = item;
                return { ccurso, cgrupo, ...rest };
              });

              return formattedGroup;
            }
          );

          return formattedGroups;
        }
      );

      // Limpiar grupos vacíos en las páginas individuales
      formattedResult.forEach((page) => {
        page.forEach((group) => {
          if (group.length === 0) {
            const pageIndex = formattedResult.findIndex((p) => p === page);
            formattedResult[pageIndex].splice(
              formattedResult[pageIndex].indexOf(group),
              1
            );
          }
        });
      });

      return formattedResult;
    }

    const paginatedData = paginateArray(datatosConstacia, 4, 8, 14);

    return paginatedData;
  };

  const datosConstan2 = (datatosConstacia) => {
    const headerHeight = 150; // Altura del encabezado de la tabla
    const rowHeight = 55; // Altura de cada fila de la tabla
    const pageHeight = 600; // Altura máxima de la página (ajústalo según tus necesidades)

    const calculateMaxRowsPerPage = () => {
      const availablePageHeight = pageHeight - headerHeight;
      return Math.floor(availablePageHeight / rowHeight);
    };

    const paginateArray = (
      data,
      maxGroupsFirstPage,
      maxGroupsPerPage,
      maxRowsPerPage
    ) => {
      const result = {};
      let currentPageIndex = 0;
      let currentGroupIndex = 0;
      let currentRowCount = 0;
      let currentPageRowCount = 0; // Contador de filas en la página actual

      const largeGroups = []; // Almacenar grupos con más de 16 elementos

      data.forEach((item) => {
        const ccurso = item.ccurso;
        const cgrupo = item.cgrupo;

        // Verificar si el grupo supera el límite de 16 elementos
        if (
          currentRowCount === 0 &&
          currentGroupIndex === 0 &&
          currentRowCount + item.length > maxRowsPerPage
        ) {
          largeGroups.push(currentGroupIndex); // Agregar el índice del grupo a largeGroups
        }

        if (
          currentRowCount === 0 &&
          currentPageIndex === 0 &&
          Object.keys(result).length >= maxGroupsFirstPage
        ) {
          currentGroupIndex++;
          if (currentGroupIndex === maxGroupsPerPage) {
            currentGroupIndex = 0;
            currentPageIndex++;
            currentPageRowCount = 0; // Reiniciar el contador de filas en la nueva página
          }
        }

        const currentPageKey = currentPageIndex.toString();

        if (!result[currentPageKey]) {
          result[currentPageKey] = {};
        }

        const currentPage = result[currentPageKey];

        const currentGroupKey = `${ccurso}-${cgrupo}`;

        if (!currentPage[currentGroupKey]) {
          currentPage[currentGroupKey] = [];
        }

        const currentGroup = currentPage[currentGroupKey];

        if (
          currentGroup.length < maxRowsPerPage &&
          currentPageRowCount < maxRowsPerPage
        ) {
          currentGroup.push(item);
          currentRowCount++;
          currentPageRowCount++;
        } else {
          currentRowCount = 0;
          currentGroupIndex++;
          currentPageRowCount = 0; // Reiniciar el contador de filas en el nuevo grupo
          if (!result[(currentPageIndex + 1).toString()]) {
            result[(currentPageIndex + 1).toString()] = {};
          }
          const nextPage = result[(currentPageIndex + 1).toString()];
          nextPage[currentGroupKey] = [item];
          currentPageIndex++;
        }
      });

      // Mover los grupos grandes a una página individual
      if (largeGroups.length > 0) {
        largeGroups.forEach((groupIndex) => {
          const groupKeys = Object.keys(result[currentPageIndex.toString()]);
          const groupKey = groupKeys[groupIndex];
          const groupData = result[currentPageIndex.toString()][groupKey];
          delete result[currentPageIndex.toString()][groupKey];
          result[(currentPageIndex + 1).toString()][groupKey] = groupData;
        });
      }

      // Limpiar grupos vacíos
      Object.values(result).forEach((page) => {
        Object.keys(page).forEach((groupKey) => {
          if (page[groupKey].length === 0) {
            delete page[groupKey];
          }
        });
      });

      // Obtener los resultados en el formato deseado
      const formattedResult = Object.entries(result).map(
        ([pageIndex, page]) => {
          const formattedGroups = Object.entries(page).map(
            ([groupKey, group]) => {
              const formattedGroup = group.map((item) => {
                const { ccurso, cgrupo, ...rest } = item;
                return { ccurso, cgrupo, ...rest };
              });

              return formattedGroup;
            }
          );

          return formattedGroups;
        }
      );

      // Limpiar grupos vacíos en las páginas individuales
      formattedResult.forEach((page) => {
        page.forEach((group) => {
          if (group.length === 0) {
            const pageIndex = formattedResult.findIndex((p) => p === page);
            formattedResult[pageIndex].splice(
              formattedResult[pageIndex].indexOf(group),
              1
            );
          }
        });
      });

      return formattedResult;
    };

    const paginatedData = paginateArray(
      datatosConstacia,
      4, // Número máximo de grupos en la primera página
      8, // Número máximo de grupos por página
      calculateMaxRowsPerPage() // Número máximo de filas por página (calculado dinámicamente)
    );

    return paginatedData;
  };

  const datosConstan = (datatosConstacia) => {
    const headerHeight = 150; // Altura del encabezado de la tabla
    const rowHeight = 55; // Altura de cada fila de la tabla
    const maxGroupsFirstPage = 4; // Número máximo de grupos en la primera página
    const maxGroupsPerPage = 5; // Número máximo de grupos por página
    const pageHeightFirstPage = 445; // Altura de la primera página
    const pageHeightOtherPages = 460; // Altura de las páginas restantes

    function calculateMaxRowsPerPage(pageHeight, headerHeight, rowHeight) {
      return Math.floor((pageHeight - headerHeight) / rowHeight);
    }

    function paginateArray(
      data,
      maxGroupsFirstPage,
      maxGroupsPerPage,
      maxRowsPerPageFirstPage,
      maxRowsPerPageOtherPages
    ) {
      const result = {};
      let currentPageIndex = 0;
      let currentGroupIndex = 0;
      let currentRowCount = 0;
      let currentPageRowCount = 0;

      const largeGroups = [];

      data.forEach((item) => {
        const ccurso = item.ccurso;
        const cgrupo = item.cgrupo;

        if (
          currentRowCount === 0 &&
          currentGroupIndex === 0 &&
          currentRowCount + item.length > maxRowsPerPageFirstPage
        ) {
          largeGroups.push(currentGroupIndex);
        }

        if (
          currentRowCount === 0 &&
          currentPageIndex === 0 &&
          Object.keys(result).length >= maxGroupsFirstPage
        ) {
          currentGroupIndex++;
          if (currentGroupIndex === maxGroupsPerPage) {
            currentGroupIndex = 0;
            currentPageIndex++;
            currentPageRowCount = 0;
          }
        }

        const currentPageKey = currentPageIndex.toString();

        if (!result[currentPageKey]) {
          result[currentPageKey] = {};
        }

        const currentPage = result[currentPageKey];

        const currentGroupKey = `${ccurso}-${cgrupo}`;

        if (!currentPage[currentGroupKey]) {
          currentPage[currentGroupKey] = [];
        }

        const currentGroup = currentPage[currentGroupKey];

        const maxRowsPerPage =
          currentPageIndex === 0
            ? maxRowsPerPageFirstPage
            : maxRowsPerPageOtherPages;

        if (
          currentGroup.length < maxRowsPerPage &&
          currentPageRowCount < maxRowsPerPage
        ) {
          currentGroup.push(item);
          currentRowCount++;
          currentPageRowCount++;
        } else {
          currentRowCount = 0;
          currentGroupIndex++;
          currentPageRowCount = 0;
          if (!result[(currentPageIndex + 1).toString()]) {
            result[(currentPageIndex + 1).toString()] = {};
          }
          const nextPage = result[(currentPageIndex + 1).toString()];
          nextPage[currentGroupKey] = [item];
          currentPageIndex++;
        }
      });

      if (largeGroups.length > 0) {
        largeGroups.forEach((groupIndex) => {
          const groupKeys = Object.keys(result[currentPageIndex.toString()]);
          const groupKey = groupKeys[groupIndex];
          const groupData = result[currentPageIndex.toString()][groupKey];
          delete result[currentPageIndex.toString()][groupKey];
          result[(currentPageIndex + 1).toString()][groupKey] = groupData;
        });
      }

      Object.values(result).forEach((page) => {
        Object.keys(page).forEach((groupKey) => {
          if (page[groupKey].length === 0) {
            delete page[groupKey];
          }
        });
      });

      const formattedResult = Object.entries(result).map(
        ([pageIndex, page]) => {
          const formattedGroups = Object.entries(page).map(
            ([groupKey, group]) => {
              const formattedGroup = group.map((item) => {
                const { ccurso, cgrupo, ...rest } = item;
                return { ccurso, cgrupo, ...rest };
              });

              return formattedGroup;
            }
          );

          return formattedGroups;
        }
      );

      formattedResult.forEach((page, index) => {
        page.forEach((group) => {
          if (group.length === 0) {
            formattedResult[index].splice(
              formattedResult[index].indexOf(group),
              1
            );
          }
        });
      });

      return formattedResult;
    }

    const maxRowsPerPageFirstPage = calculateMaxRowsPerPage(
      pageHeightFirstPage,
      headerHeight,
      rowHeight
    );
    const maxRowsPerPageOtherPages = calculateMaxRowsPerPage(
      pageHeightOtherPages,
      headerHeight,
      rowHeight
    );

    const paginatedData = paginateArray(
      datatosConstacia,
      maxGroupsFirstPage,
      maxGroupsPerPage,
      maxRowsPerPageFirstPage,
      maxRowsPerPageOtherPages
    );

    return paginatedData;
  };

  const handleDescargaConstacia = async (e, { cconstancia, darchivo }) => {
    e.preventDefault();

    if (cconstancia === 1) {
      try {
        setLoading(true);

        let datatosConstacia = [];
        // if ([darchivo].includes("") || [darchivo].includes(null)) {
          datatosConstacia = await listado_constacias_datosconstancia(
            obtenerDatosEstudiante
          );
        // }

        await generatePdf(
          datatosConstacia,
          { cconstancia, darchivo },
          obtenerDatosEstudiante
        );

      } catch (error) {
        let modalErrorr = document.querySelector("#modalErr");

        if (modalErrorr) {
          modalErrorr.click();
          // setErrorServices(true)
          setErrorCursoServices(error.message);
        }
      } finally {
        setLoading(false);
      }
    }
    if (cconstancia === 2) {
      try {
        setLoading(true);
        let datatosConstacia = [];
        // if ([darchivo].includes("") || [darchivo].includes(null)) {
          datatosConstacia = await listado_constacias_cronogramapagos(
            obtenerDatosEstudiante
          );
        // }
        await generatePdf(
          datatosConstacia,
          { cconstancia, darchivo },
          obtenerDatosEstudiante
        );

      } catch (error) {
        let modalErrorr = document.querySelector("#modalErr");

        if (modalErrorr) {
          modalErrorr.click();
          // setErrorServices(true)
          setErrorCursoServices(error.message);
        }
      } finally {
        setLoading(false);
      }
    }
    if (cconstancia === 3) {
      try {
        setLoading(true);
        let datatosConstacia = [];
        // if ([darchivo].includes("") || [darchivo].includes(null)) {

          datatosConstacia = await listado_constacias_datoshorario(
            obtenerDatosEstudiante
          );
        // }


        let datosConstanciaMin = datatosConstacia;

        await generatePdf(
          datosConstanciaMin,
          { cconstancia, darchivo },
          obtenerDatosEstudiante
        );
      } catch (error) {
        setLoading(false);
        let modalErrorr = document.querySelector("#modalErr");

        if (modalErrorr) {
          modalErrorr.click();
          // setErrorServices(true)
          setErrorCursoServices(error.message);
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const getFormattedDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // El mes va de 0 a 11, por eso se le suma 1 y se rellena con ceros
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const formattedDateTime = `${year}${month}${day}${hours}${minutes}${seconds}`;
    return formattedDateTime;
  };

  const abrirEnNuevaPestana = (url) => {
    window.open(url, "_blank");
  };

  const generatePdf = async (
    datatosConstacia,
    { cconstancia, darchivo },
    obtenerDatosEstudiante
  ) => {
    const nameFile = `${dperiodo +
      "_" +
      ndocidentidad +
      "_" +
      cconstancia +
      "_" +
      calumno +
      "_" +
      cpersona +
      "_" +
      cprograma
      }_${getFormattedDateTime()}.pdf`;
    if ([darchivo].includes("") || [darchivo].includes(null)) {

      try {
        // Generar el blob del PDF
        let pdfBlob;
        if (cconstancia === 1) {
          pdfBlob = await pdf(
            <ConstanciaMatricula datatosConstacia={datatosConstacia} />
          ).toBlob();
        }
        if (cconstancia === 2) {
          pdfBlob = await pdf(
            <CronogramaDePago
              datatosConstacia={datatosConstacia}
              obtenerDatosEstudiante={obtenerDatosEstudiante}
            />
          ).toBlob();
        }

        if (cconstancia === 3) {
          let datosConst = datosConstan(datatosConstacia);
          pdfBlob = await pdf(
            <HorarioPdf datatosConstacia={datosConst} />
          ).toBlob();
        }

        const base64 = await convertBlobToBase64(pdfBlob);
        const cadenaSinPrefijo = base64.replace(/^data:[^;]+;base64,/, "");

        let { url } = await insertarApiUploadFile({
          nombreFile: nameFile,
          base64File: cadenaSinPrefijo,
        });

        await insertRutaConstancia(obtenerDatosEstudiante, {
          cconstancia: cconstancia,
          darchivo: url,
        });

        abrirEnNuevaPestana(url);

        await listado_constacias_habilitadas_sinLoading(
          obtenerDatosEstudiante,
          setListConstanciaHabilitadas
        );

      } catch (error) {

        let modalErrorr = document.querySelector("#modalErr");

        if (modalErrorr) {
          modalErrorr.click();
          setErrorCursoServices(error.message);
        }
      }
    } else {
      abrirEnNuevaPestana(darchivo);
    }
  };

  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  };
  return listConstanciaHabilitadas[0]?.respuesta === 1 && sinTitulo ? (
    <div className={`card  mt-4 mb-4 ${sinTitulo ? "shadow-sm" : ""}`}>
      <div className="card-body">
        {sinTitulo && (
          <h6 className="text-uppercase mb-4">Documentos de matrícula</h6>
        )}

        <div
          className={` buttons-download  ${sinTitulo ? "my-3" : "d-flex justify-content-evenly"
            }`}
        >
          {listConstanciaHabilitadas.map((datos) => {
            return (
              <a
                key={datos?.cconstancia}
                onClick={(e) => {
                  handleDescargaConstacia(e, datos);
                }}
                target="_blank"
                className={`${sinTitulo ? "btn-sm mb-3 mx-2 btn-ico-down" : "w-230 "
                  }   d-flex align-items-center justify-content-center me-3 btn-outline-danger btn ${datos.ndescarga === 0 ? "btn-outline-danger" : "btn-primary"
                  }`}
              >
                <svg
                  width={14}
                  height={13}
                  viewBox="0 0 16 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 10.3125H10.8281L9.41406 11.6382C9.0375 11.9912 8.53438 12.1875 8 12.1875C7.46562 12.1875 6.96375 11.9925 6.58594 11.6382L5.17188 10.3125H1C0.447812 10.3125 0 10.7323 0 11.25V14.0625C0 14.5802 0.447812 15 1 15H15C15.5522 15 16 14.5802 16 14.0625V11.25C16 10.7314 15.5531 10.3125 15 10.3125ZM13.5 13.3594C13.0875 13.3594 12.75 13.043 12.75 12.6562C12.75 12.2695 13.0875 11.9531 13.5 11.9531C13.9125 11.9531 14.25 12.2695 14.25 12.6562C14.25 13.043 13.9125 13.3594 13.5 13.3594ZM7.29375 10.9746C7.4875 11.1592 7.74375 11.25 8 11.25C8.25625 11.25 8.51188 11.1584 8.70687 10.9753L12.7069 7.22534C13.0972 6.85913 13.0972 6.26587 12.7069 5.89966C12.3162 5.53345 11.6831 5.53345 11.2928 5.89966L9 8.05078V0.9375C9 0.419824 8.55219 0 8 0C7.44688 0 7 0.419824 7 0.9375V8.05078L4.70625 5.90039C4.31594 5.53418 3.68281 5.53418 3.29219 5.90039C2.90188 6.2666 2.90188 6.85986 3.29219 7.22607L7.29375 10.9746Z"
                    fill={`${datos.ndescarga === 0 ? "#B01333" : "#fff"}`}
                  />
                </svg>
                <span className="ms-2">{datos?.dconstancia}</span>{" "}
              </a>
            );
          })}
        </div>
      </div>

      <button
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#errorCurso"
        id="modalErr"
      ></button>
    </div>
  ) : (
    sinTitulo == false && (
      <>
        <div className="success-animation d-none d-md-block d-lg-block">
          {listConstanciaHabilitadas[0]?.mensaje.split("|")[0] === "success" ? (
            <svg
              className="checkmark-animation"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="checkmark__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark__check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
          ) : listConstanciaHabilitadas[0]?.mensaje.split("|")[0] ===
            "warning" ? (
            <svg
              className="warning-animation"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="warning__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <text
                x="50%"
                y="45%"
                fontSize="35"
                textAnchor="middle"
                alignmentBaseline="central"
                fill="#FFD500"
              >
                !
              </text>
            </svg>
          ) : listConstanciaHabilitadas[0]?.mensaje.split("|")[0] ===
            "danger" ? (
            <svg
              className="danger-animation"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="danger__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark__x"
                fill="none"
                d="M16 16 L36 36 M36 16 L16 36"
              />
            </svg>
          ) : listConstanciaHabilitadas[0]?.mensaje.split("|")[0] === "info" ? (
            <svg
              className="info-animation"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="info__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <text
                x="50%"
                y="35%"
                fontSize="35"
                textAnchor="middle"
                alignmentBaseline="central"
                fill="#7070ff"
                dominantBaseline="middle"
              >
                ¡
              </text>
            </svg>
          ) : (
            <></>
          )}
        </div>

        <div className="text-center confirmation-title mb-2">
          <h3 className="text-uppercase ">
            {listConstanciaHabilitadas[0]?.mensaje.split("|")[1]}{" "}
          </h3>

          <p className="mb-0">
            {listConstanciaHabilitadas[0]?.mensaje.split("|")[2]}
          </p>
        </div>
        <div className={`card  mt-4 mb-4 ${sinTitulo ? "shadow-sm" : ""}`}>
          <div className="card-body">
            {sinTitulo && (
              <h6 className="text-uppercase mb-4">Documentos de matrícula</h6>
            )}

            <div
              className={` buttons-download  ${sinTitulo ? "my-3" : "d-flex justify-content-evenly"
                }`}
            >
              {listConstanciaHabilitadas[0]?.respuesta === 1 &&
                listConstanciaHabilitadas.map((datos) => {
                  return (
                    <a
                      key={datos?.cconstancia}
                      onClick={(e) => {
                        handleDescargaConstacia(e, datos);
                      }}
                      target="_blank"
                      className={`${sinTitulo ? "btn-sm mb-3 mx-2 btn-ico-down" : "w-230 "
                        }   d-flex align-items-center justify-content-center me-3 btn-outline-danger btn ${datos.ndescarga === 0
                          ? "btn-outline-danger"
                          : "btn-primary"
                        }`}
                    >
                      <svg
                        width={14}
                        height={13}
                        viewBox="0 0 16 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 10.3125H10.8281L9.41406 11.6382C9.0375 11.9912 8.53438 12.1875 8 12.1875C7.46562 12.1875 6.96375 11.9925 6.58594 11.6382L5.17188 10.3125H1C0.447812 10.3125 0 10.7323 0 11.25V14.0625C0 14.5802 0.447812 15 1 15H15C15.5522 15 16 14.5802 16 14.0625V11.25C16 10.7314 15.5531 10.3125 15 10.3125ZM13.5 13.3594C13.0875 13.3594 12.75 13.043 12.75 12.6562C12.75 12.2695 13.0875 11.9531 13.5 11.9531C13.9125 11.9531 14.25 12.2695 14.25 12.6562C14.25 13.043 13.9125 13.3594 13.5 13.3594ZM7.29375 10.9746C7.4875 11.1592 7.74375 11.25 8 11.25C8.25625 11.25 8.51188 11.1584 8.70687 10.9753L12.7069 7.22534C13.0972 6.85913 13.0972 6.26587 12.7069 5.89966C12.3162 5.53345 11.6831 5.53345 11.2928 5.89966L9 8.05078V0.9375C9 0.419824 8.55219 0 8 0C7.44688 0 7 0.419824 7 0.9375V8.05078L4.70625 5.90039C4.31594 5.53418 3.68281 5.53418 3.29219 5.90039C2.90188 6.2666 2.90188 6.85986 3.29219 7.22607L7.29375 10.9746Z"
                          fill={`${datos.ndescarga === 0 ? "#B01333" : "#fff"}`}
                        />
                      </svg>
                      <span className="ms-2">{datos?.dconstancia}</span>{" "}
                    </a>
                  );
                })}
            </div>
          </div>

          <button
            style={{ display: "none" }}
            data-bs-toggle="modal"
            data-bs-target="#errorCurso"
            id="modalErr"
          ></button>
        </div>
      </>
    )
  );
};

export default DocumentosMatricula;
